// extracted by mini-css-extract-plugin
module.exports = {"tabsNav":"Tabs_tabsNav__1de6R","link":"Tabs_link__3nTO2"};